import Vue from 'vue'
import UserMixin from '@/components/helpers/mixins/user-mixin'

export default Vue.extend({
  template: `
        <div class="role-box">
            <b-badge
              v-for="(role, index) in this.params.data.roles"
              :key="index"
              :variant="$_userMixin_getBadge(role.title)"
              class="role-badge"
              v-b-tooltip.hover
              :title="$_userMixin_roleTranslate(role.title)"
            >
              {{ $_userMixin_roleTranslateBadge(role.title) }}
            </b-badge>
        </div>
  `,
  mixins: [UserMixin]
})
